import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TipHeading } from "./TipHeading";
import { TipText } from "./TipText";
export const FifthTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        children: [
            children,
            /*#__PURE__*/ _jsx(TipHeading, {
                className: headingClassName,
                children: "Avoid copyrighted material"
            }),
            /*#__PURE__*/ _jsx(TipText, {
                children: "Avoid copyrighted material or anything that might have to be cleared separately. All submissions will require a release indicating that you are solely responsible for the content."
            })
        ]
    });
};
